module.exports = __webpack_public_path__ + "img/gaku_text_06.1579c6b6.png";